import { MenuIcon } from '@shopify/polaris-icons'
import { useEffect, useState } from 'react'

import { Logo } from '../../shared/components/Logo'
import { useSidebar } from '../providers/SidebarProvider'
import './MobileHeader.css'

export function MobileHeader() {
  const [isMobile, setIsMobile] = useState(false)
  const { isMobileSidebarOpen, setMobileSidebarOpen } = useSidebar()

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth <= 768
      setIsMobile(mobile)
      if (!mobile) {
        setMobileSidebarOpen(false)
      }
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [setMobileSidebarOpen])

  const handleMenuToggle = () => {
    setMobileSidebarOpen(!isMobileSidebarOpen)
  }

  if (!isMobile) {
    return null
  }

  return (
    <>
      <header className="mobile-header">
        <button
          className="mobile-menu-button"
          onClick={handleMenuToggle}
          aria-label="Toggle navigation menu"
        >
          <MenuIcon />
        </button>
        <Logo showTitle={true} titleClassName="logo-title" />
      </header>

      {/* Mobile overlay */}
      {isMobileSidebarOpen && (
        <div
          className="mobile-overlay"
          onClick={handleMenuToggle}
          aria-hidden="true"
        />
      )}
    </>
  )
}
